import { ComponentInstall } from "../../utils";
import Tooltips from "./src";

export default ComponentInstall(Tooltips);
